window.ddjskey = "C0705ACD75EBF650A07FF8291D3528";

(function ($, data) {
    $(function() {
        const hasSelectNav = data['select-nav'].Enabled === true

        if (hasSelectNav) {
            $('body').addClass('with-select-nav')
        }
    });
})(jQuery, app.data);
